module.exports = __webpack_public_path__ + "static/media/course-own.1a096806.png";